/**
 * 引用三方JS、CSS文件地址
 * alon(250079279@qq.com) - 2022-01-06
 */
/**
 * 加载三方js文件
 * @param url 文件地址
 * @returns
 */
export async function remoteLoadScript(url) {
  return new Promise(function (resolve, reject) {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `${url}`;
    script.onerror = reject;
    document.head.appendChild(script);
    script.onload = () => {
      resolve(script);
    };
  });
}
/**
 * 加载三方css文件
 * @param url 文件地址
 * @returns
 */
export async function remoteLoadCss(url) {
  return new Promise(function (resolve, reject) {
    let css = document.createElement("link");
    css.rel = "stylesheet";
    css.href = `${url}`;
    css.onerror = reject;
    document.head.appendChild(css);
  });
}
